"use client";

import { useBookCallPopupOptional } from "@/components/booking/CcBookCallPopupProvider";
import { shouldOpenBookCallPopup } from "@/lib/book-call-cta-label";

/** True when CTA should open book-call popup (provider present or label heuristics). */
export function useOpensBookCallPopup(label?: string): boolean {
  const bookCallPopupCtx = useBookCallPopupOptional();
  if (bookCallPopupCtx) {
    return true;
  }
  return shouldOpenBookCallPopup(false, label);
}
